module.exports = __webpack_public_path__ + "static/4500-3-quarter-close-47a4ce4085d9dccad1d52942c3f428c8.jpg";